import { Component, Input } from '@angular/core';

@Component({
  selector: 'sketch-status-light',
  templateUrl: './status-light.component.html',
  styleUrls: ['./status-light.component.scss']
})
export class StatusLightComponent {
  
  @Input() status: string = '';

  errorStatuses = ['Cancelled', 'Cred Held', 'Date T.B.A', 'Date Passed', 'Inactive'];
  warningStatuses = ['Invoiced', 'Processing', 'Ready for Despatch', 'Out for Delivery'];
  successStatuses = ['Delivered', 'Active', ];

  statusClass: string = '';
  bgClass: string = ''; 

  constructor() { }

  ngOnInit(): void {
    this.load(); 
  }
  ngOnChanges(){
    this.load(); 
  }

  load(){
    this.statusClass = this.getStatusLight(); 
    this.bgClass = this.getBgClass(); 
  }

  getBgClass(){
    if (this.errorStatuses.includes(this.status)) {
      return 'bg-error';
    }
    if (this.warningStatuses.includes(this.status)) {
      return 'bg-warning';
    }
    if (this.successStatuses.includes(this.status)) {
      return 'bg-success';
    }
    return 'bg-error';
  }

  getStatusLight() {
    if (this.errorStatuses.includes(this.status)) {
      return 'red-circle';
    }
    if (this.warningStatuses.includes(this.status)) {
      return 'amber-circle';
    }
    if (this.successStatuses.includes(this.status)) {
      return 'green-circle';
    }
    return 'red-circle';
  }
}